module.exports = __webpack_public_path__ + "static/media/3DPPA44.3b638d63.jpg";